import Joi from 'joi';
import { actionCreator, objectSchemaOf } from '../helpers';

export const STOP = 'VOICE_TO_TEXT/STOP';

export const stopActionSchema = objectSchemaOf<IStopAction>({
  type: Joi.string().required().valid(STOP),
  payload: objectSchemaOf<IStopAction['payload']>({
    conversationId: Joi.string().required(),
  }).required(),
});

export interface IStopAction {
  type: typeof STOP;
  payload: {
    conversationId: string;
  };
}

export const stop = actionCreator({
  type: STOP,
  schema: stopActionSchema,
});
